import { Component, OnInit } from '@angular/core';
import { DataServiceService } from '../../mappers/data-service.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public samplePagesCollapsed = true;
  public userRole : any;
  constructor(
    private userData: DataServiceService
  ) { }

  ngOnInit() {
    this.userRole = JSON.parse(localStorage.getItem('userInfo')).role;
    //this.userData.currentUserRole.subscribe(message => this.userRole = message)
    console.log('user role----->', this.userRole);
  }

}
